import { NgClass } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions } from "@angular/material/dialog";
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { Data, Router } from '@angular/router';
import { AuthService } from '@core/auth.service';
import { AuthGamesService } from '@core/AuthServices/authGames/auth-games.service';
import { isMobile } from "@core/utility.service";
import { IonicModule } from '@ionic/angular';
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { interval, Observable, Subscription } from 'rxjs';
import { CommonVariable, Orientation } from 'src/app/app.constants';
import { GamePlayComponent } from 'src/app/components/game-play/game-play.component';
import { WindowsGamePlayPopupComponent } from 'src/app/components/windows-game-play-popup/windows-game-play-popup.component';
import { GamesFeedSampleService } from 'src/app/pages/games-feed-sample/games-feed-sample.service';
import { GTMSagmentService } from 'src/app/services/gtm-sagment.service';
import { OrientationService } from 'src/app/services/orientation.service';
import { CountDownTimerComponent } from '../../../count-down-timer/count-down-timer.component';


@Component({
    selector: 'app-social-game-preview',
    templateUrl: './social-game-preview.component.html',
    styleUrls: ['./social-game-preview.component.scss'],
    standalone: true,
    imports: [
        MatDialogActions,
        MatButton,
        IonicModule,
        CountDownTimerComponent,
        NgClass,
        MatProgressSpinner,
        TranslatePipe,
    ],
})
export class SocialGamePreviewComponent implements OnInit {
  spinnerAnimation: boolean;
  timer$: Observable<number>;
  sub: Subscription;
  languageCode: string;
  selectedLanguage: string;
  public spanish: boolean;
  proceed = true;
  public preferredCurrency: string;
  progressBar: number;
  gameData: Data;
  rapidFireDetails: Data;
  gameOrientation: Orientation;
  private isPlayInProgress = false;
  userGameRestriction:boolean;

  constructor(
    private orientationService: OrientationService,
    private matDialog: MatDialog,
    private GTMSegment: GTMSagmentService,
    private authService: AuthService,
    public gamesFeedService: GamesFeedSampleService,
    private changeDetectorRef: ChangeDetectorRef,
    public translate: TranslateService,
    private router: Router,
    private bottomSheet: MatBottomSheet,
    private authGamesService: AuthGamesService,
    @Inject(MAT_DIALOG_DATA) public data: Data
  ) {
    this.languageCode = "en";
    this.gameData = data;
    console.log("GameDAta=>", data)
    this.authService?.userDetails$?.subscribe((user: Data) => {
      this.languageCode = user?.language_code ? user?.language_code : "en";
      this.preferredCurrency = user?.preferred_currency ?? CommonVariable.preferredCurrency;
      this.userGameRestriction = user?.gameplay_restriction || false;
    });
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l ? l : "en";
        translate.use(l ? l : "en");
        if (l == "es") {
          this.spanish = true;
        }
      },
      (err) => {
        return err;
      }
    );
  }
  closeDialog() {
    this.matDialog.closeAll();
  }
  ngOnInit(): void {
    let topPrize = this.gameData?.gameData?.ref?.top_prize;
    if (topPrize) {
      topPrize = topPrize.replace(" Cash", "");
      topPrize = topPrize.replace(" Credit", "Cr");
      this.authService
        .getDVFromString(topPrize)
        .then((resp: string) => {
          this.gameData.gameData.ref["top_prize"] = resp;
        })
        .catch((err) => {
          return err;
        });
    }
    let int_game_short_title = this.gameData?.gameData.ref?.int_game_popup_details[this.selectedLanguage ?? 'en'];
    if (int_game_short_title) {
      this.authService
        .getDVFromString(int_game_short_title)
        .then((resp: string) => {
          this.gameData.gameData.ref["int_game_short_title"] = resp;
        })
        .catch((err) => {
          return err;
        });
    }
    const mustWinPrize =
    this.gameData.gameData.ref?.int_must_win_prize
      ? this.gameData.gameData.ref?.int_must_win_prize[this.selectedLanguage] ?? this.gameData.gameData.ref?.int_must_win_prize['en']
      : this.gameData?.gameData.ref?.must_win_prize;
  
    if (mustWinPrize) {
      this.authService
        .getDVFromString(mustWinPrize)
        .then((resp: string) => {
          this.gameData.gameData.ref["must_win_prize"] = resp;
        })
        .catch((err) => {
          return err;
        });
    }
    const gameShortTitle = this.gameData?.gameData.ref?.int_game_short_title
      ? this.gameData?.gameData.ref?.int_game_short_title[this.selectedLanguage]
      ?? this.gameData.gameData.ref?.int_game_short_title['en']
      : this.gameData?.gameData.ref?.game_short_title;

    if (gameShortTitle) {
      this.authService
        .getDVFromString(gameShortTitle)
        .then((resp: string) => {
          this.gameData.gameData.ref["game_short_title"] = resp;
        })
        .catch((err) => {
          return err;
        });
    }
    this.gamesFeedService?.getRapidFireDetails$?.subscribe((ref: Data) => {
      this.rapidFireDetails = ref[0]?.rapid_fire;
      this.rapidFireDetails.draw_date = ref[1]?.expiry_date;
    });

  }

  startSpinner() {
    this.spinnerAnimation = true;
    this.progressBar = 0;
    this.timer$ = interval(20);
    this.sub = this.timer$.subscribe(
      (sec) => {
        this.progressBar = 0 + sec;
        this.changeDetectorRef.detectChanges();
      },
      (err) => {
        return err;
      }
    );
  }

  async playGame(gamePreviewData) {
    this.matDialog.closeAll();
    const gamePrice = gamePreviewData?.sale_price || gamePreviewData?.game_price;
    if(!this.userGameRestriction){
      this.GTMSegment.HotJarEvent("user_played_game");
      this.gameOrientation = gamePreviewData?.orientation as Orientation;
      if (!isMobile.any() && gamePreviewData?.orientation == "landscape") {
        this.matDialog.open(WindowsGamePlayPopupComponent, {
          hasBackdrop: true,
        });
        return null;
      }
      if (!window.navigator.onLine) return;
      this.startSpinner();
      gamePreviewData.document = "/api_post_request/customer_game_token_authentication";
      gamePreviewData.from_page = "social-game-preview";
      gamePreviewData.user_game_restriction = this.userGameRestriction;
      if (this.isPlayInProgress) return;
      this.isPlayInProgress = true;
      this.gamesFeedService
        .getUserGameInfo(gamePreviewData)
        .then((data: string) => {
          this.isPlayInProgress = false;
          this.progressBar === 100;
          this.sub?.unsubscribe();

          setTimeout(() => {
            this.spinnerAnimation = false;
            this.proceed = false;
            setTimeout(() => {
              this.proceed = true;
            }, 2000);
          }, 300);

          this.openPlayGame(data);
        })
        .catch((data) => {
          this.isPlayInProgress = false;
          try {
            const translatedMsg = {
              message: {
                line_1: data?.message,
                line_2: "",
              },
              style: {
                duration: 2000,
                icon: "tick circle error.svg",
                type: "Error",
              },
            };
            const defaultMsg = {
              message: {
                line_1: "Something went wrong!",
                line_2: "",
              },
              style: {
                icon: "tick circle error.svg",
                type: "Error",
              },
            };
            this.authService.showToastMessage(translatedMsg, defaultMsg);
            return data;
          } catch (e) {
            return e;
          }
        });
    } else {
        this.authGamesService?.liftRestrictionInboxMessage(gamePrice);
        this.authService.getConstantsMsg("1148")
        .then((translatedMsg) => {
          const message = "You have reached the game play limit";
          const defaultMsg = {
            message: {
              line_1: message,
              line_2: "",
            },
            style: {
              icon: "tick circle error.svg",
              type: "Error",
            },
          };
          this.authService.showToastMessage(translatedMsg, defaultMsg);
        })
        .catch((error) => {
          return error;
        });
      }
  }

  private async openPlayGame(res: string) {
    if (isMobile.Android()) {
      this.orientationService.enterFullscreen();
      this.orientationService.lockOrientation(this.gameOrientation);
    }
    this.matDialog.open(GamePlayComponent, {
      height: "100%",
      width: "100%",
      data: { data: res },
    });
  }

  goToGameDetails(adventure_id: number, gameTypeId: number, gameId: number, category: string) {
    this.matDialog.closeAll();
    this.bottomSheet.dismiss();
    if (gameTypeId && gameId && category) {
      const gameDetailUrl = category.toLowerCase().replace(" ", "-");
      this.matDialog.closeAll();
      if (gameDetailUrl == "rapid-fire") {
        const url = "https://web.lottosocial.com/rapid-fire/";
        window.open(url, "_blank");
      }
      else {
        if (gameTypeId !== 10) {
          if (gameTypeId == 9) {
            this.router.navigateByUrl(`games/${gameDetailUrl}-game/${adventure_id}`);
          } else {
            this.router.navigateByUrl(`games/${gameDetailUrl}-game/${gameId}`);
          }
        } else if (gameTypeId === 10) {
          this.router.navigateByUrl(`games/replayable/${gameId}`);
        }
      }
    }
  }

}
